export class Product {
  advisories: Advisory[];
  sku: string;
  name: string;
  manufacturerPartNumber: string;
  manufacturerName: string;
  unitOfMeasure: string;
  productImages: { url: string, type: number }[];
  productPricing: {
    listPrice: number;
  };
  quantity: number;
  minimumQuantity: number;
  returnPolicy: string;
  bookLineNum: number;
  isCatitemHazmatFormReq: boolean;
  isHazmatItem: boolean;
  isTuningItem: boolean;
  tuningLaborSku: string;
  getAskCustomerQuestions: string;
  listPrice: number;

  // used in the UI
  showAdvisoryQuestion: boolean;
  isCableItem: boolean;
  imageUrl: string;
  advisorySortOrder: number;
  isConsignedItem: boolean;
}

export enum ProductTuningType {
  TUNABLE_NOT = 0,
  TUNABLE_OPTIONAL = 1,
  TUNABLE = 2
}

export class Advisory {
  advisoryId: string;
  advisoryType: string;
  materialType: string;
  value: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/product.ts